import { render, staticRenderFns } from "./UpdateBtn.vue?vue&type=template&id=56f1880e&"
import script from "./UpdateBtn.vue?vue&type=script&lang=js&"
export * from "./UpdateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports